import React from "react";

import { Grid } from "@material-ui/core";
import { Link, useHistory } from "react-router-dom";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";

import { IAuth } from "../../models";
import { useApp } from "../../contexts";
import { paletas } from "../../styles/theme";
import packageJson from "../../../package.json";
import { Wrapper, Menu, BotaoMenu, Versao } from "./styles";
import Divisor from "../divisor";
import StatusDev from "./statusDev";

export default function Header() {
  const { setUsuarioAutenticado } = useApp();
  const [abrirMenu, setAbrirMenu] = React.useState(false);
  const history = useHistory();

  const fazerLogout = () => {
    let dadosNull: IAuth = {
      email: "",
      token: "",
    };
    setUsuarioAutenticado(dadosNull);
    localStorage.removeItem("@batalha-dev/usuario");
    localStorage.removeItem("@batalha-dev/autenticado");
    history.push("/");
  };

  return (
    <>
      <Menu>
        {abrirMenu && (
          <nav>
            <ul>
              <li>
                <Link to="/home">Home</Link>
              </li>
              <li>
                <Link to="/configuracoes">Configurações</Link>
              </li>
              <li>
                <Link to="/recarga">Recarga</Link>
              </li>
              <li>
                <Link to="/conta">Conta</Link>
              </li>
              <li>
                <button onClick={fazerLogout}>Logout</button>
              </li>
            </ul>
            <Versao>v.{packageJson.version}</Versao>
          </nav>
        )}
      </Menu>

      <Wrapper>
        <Grid container justify="space-between">
          <Grid item xs={10} sm={6} md={4}>
            <StatusDev />
          </Grid>

          <BotaoMenu
            aria-label="Abrir/Fechar menu"
            onClick={() => setAbrirMenu(!abrirMenu)}
          >
            {!abrirMenu ? (
              <AiOutlineMenu size="16px" />
            ) : (
              <AiOutlineClose size="16px" />
            )}
          </BotaoMenu>
        </Grid>
      </Wrapper>

      <Divisor color={paletas.DarkOrange} />
    </>
  );
}
